import React from "react";
// Outlined button

// Mui
import Button from "@mui/material/Button";
import { SxProps, Theme } from "@mui/material/styles";

// Types
interface OutlinedButtonProps {
  label: React.ReactNode | string;
  className?: string;
  onClick?: () => void;
  color?: string;
  bgColor?: string;
  borderColor?: string;
  hoverBgColor?: string;
  hoverBorderColor?: string;
  hoverColor?: string;
  sx?: SxProps<Theme>;
  borderWidth?: string;
  hoverBorderWidth?: string;
  onDragStart?: (event: React.DragEvent<HTMLButtonElement>) => void;
  draggable?: boolean;
  border?: boolean;
}

const OutlinedButton: React.FC<OutlinedButtonProps> = ({
  label,
  className,
  onClick,
  color,
  bgColor,
  borderColor,
  hoverBgColor,
  hoverBorderColor,
  hoverColor,
  sx,
  borderWidth,
  hoverBorderWidth,
  onDragStart,
  draggable = false,
  border = true,
}) => {
  return (
    <Button
      variant="outlined"
      className={className}
      onClick={onClick}
      sx={{
        padding: "8px 15px",
        fontFamily: "Figtree",
        fontSize: "13px",
        fontWeight: 500,
        lineHeight: "15px",
        letterSpacing: "0.32px",
        borderRadius: "5px",
        textTransform: "none",
        color: color,
        background: bgColor,
        border: border ? `${borderWidth} solid ${borderColor}` : "none",
        "&:hover": {
          background: hoverBgColor,
          border: `${hoverBorderWidth} solid ${hoverBorderColor}`,
          color: hoverColor,
        },
        ...sx,
      }}
      onDragStart={onDragStart}
      draggable={draggable}
    >
      {label}
    </Button>
  );
};

export default OutlinedButton;
